export default __webpack_public_path__ + "static/mlp logo-11bbd7c1d83fbe20c4835fbbe79ff95f.svg";